// User constant

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILED = "LOGIN_REQUEST_FAILED";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const LOG_OUT_USER = "LOG_OUT_USER";
export const LOGOUT_DETAILS = "LOGOUT_DETAILS";

export const REQUEST_STARTED = "REQUEST_STARTED";
export const REQUEST_COMPLETED = "REQUEST_COMPLETED";
export const FILE_UPLOAD_STARTED = "FILE_UPLOAD_STARTED";
export const FILE_UPLOAD_COMPLETED = "FILE_UPLOAD_COMPLETED";

export const APP_ERROR = "APP_ERROR";
export const APP_MODAL_ERROR = "APP_MODAL_ERROR";
export const RESET_LOADER = "RESET_LOADER";
export const CLOSE_ERROR = "CLOSE_ERROR";
export const CLOSE_MODAL_ERROR = "CLOSE_MODAL_ERROR";

//To get user list
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";

//To get user list by id
export const GET_USER_ID_SUCCESS = "GET_USER_ID_SUCCESS";
export const GET_USER_ID_ERROR = "GET_USER_ID_ERROR";

//To edit user list
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_ERROR = "EDIT_USER_ERROR";

//To edit user list
export const EDIT_USER_IMAGE_SUCCESS = "EDIT_USER_IMAGE_SUCCESS";
export const EDIT_USER_IMAGE_ERROR = "EDIT_USER_IMAGE_ERROR";

//To delete user list
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

//To update course terms
export const UPDATE_COURSE_TERMS_SUCCESS = "UPDATE_COURSE_TERMS_SUCCESS";
export const UPDATE_COURSE_TERMS_ERROR = "UPDATE_COURSE_TERMS_ERROR";

export const UPDATE_LEAVRNING_CHECKLIST_SUCCESS =
  "UPDATE_LEAVRNING_CHECKLIST_SUCCESS";
export const UPDATE_LEAVRNING_CHECKLIST_ERROR =
  "UPDATE_LEAVRNING_CHECKLIST_ERROR";

export const GET_SINGLE_COURSE_ATTENDEE = "GET_SINGLE_COURSE_ATTENDEE";
export const GET_SINGLE_COURSE_ATTENDEE_ERROR =
  "GET_SINGLE_COURSE_ATTENDEE_ERROR";

//To update evaluation course terms
export const UPDATE_COURSE_EVALUATION_TERMS_SUCCESS =
  "UPDATE_COURSE_TERMUPDATE_COURSE_EVALUATION_TERMS_SUCCESSS_SUCCESS";
export const UPDATE_COURSE_EVALUATION_TERMS_ERROR =
  "UPDATE_COURSE_EVALUATION_TERMS_ERROR";

export const GET_SINGLE_COURSE_EVALUATION_ATTENDEE =
  "GET_SINGLE_COURSE_EVALUATION_ATTENDEE";
export const GET_SINGLE_COURSE_EVALUATION_ATTENDEE_ERROR =
  "GET_SINGLE_COURSE_EVALUATION_ATTENDEE_ERROR";

// update Learning verfication
export const UPDATE_LEARNING_VERIFICATION_SUCCESS =
  "UPDATE_LEARNING_VERIFICATION_SUCCESS";
export const UPDATE_LEARNING_VERIFICATION_ERROR =
  "UPDATE_LEARNING_VERIFICATION_ERROR";

// update Learning verfication
export const GET_LEARNER_VERIFICATION_FACILITATOR_SUCCESS =
  "GET_LEARNER_VERIFICATION_FACILITATOR_SUCCESS";
export const GET_LEARNER_VERIFICATION_FACILITATOR_ERROR =
  "GET_LEARNER_VERIFICATION_FACILITATOR_ERROR";

// update Learning verfication
export const SHOW_GRADEBOOK_FINALIZE_SUCCESS =
  "SHOW_GRADEBOOK_FINALIZE_SUCCESS";
export const SHOW_GRADEBOOK_FINALIZE_ERROR = "SHOW_GRADEBOOK_FINALIZE_ERROR";

//To delete user list
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_FAILED = "GET_ALL_USER_FAILED";

//To add user list
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_ERROR = "ADD_USER_ERROR";
export const SET_TOP_MENU = "SET_TOP_MENU";
export const SET_SIDE_MENU = "SET_SIDE_MENU";
export const ADD_BULK_USERS_SUCCESS = "ADD_BULK_USERS_SUCCESS";

export const RESET_USER_DETAILS = "RESET_USER_DETAILS";
// Terms

export const GET_TERMS_SUCCESS = "GET_TERMS_SUCCESS";
export const GET_TERMS_FAILED = "GET_TERMS_FAILED";

export const CREATE_TERMS_SUCCESS = "CREATE_TERMS_SUCCESS";
export const CREATE_TERMS_FAILED = "CREATE_TERMS_FAILED";

export const UPDATE_TERMS_SUCCESS = "UPDATE_TERMS_SUCCESS";
export const UPDATE_TERMS_FAILED = "UPDATE_TERMS_SUCCESS";

export const DELETE_TERMS_SUCCESS = "DELETE_TERMS_SUCCESS";
export const DELETE_TERMS_FAILED = "DELETE_TERMS_FAILED";

export const RESET_TERMS_DETAILS = "RESET_TERMS_DETAILS";

export const GET_ALL_TERMS_SUCCESS = "GET_ALL_TERMS_SUCCESS";
export const GET_ALL_TERMS_FAILED = "GET_ALL_CAMPUS_FAILED";

// Campus

export const GET_CAMPUS_SUCCESS = "GET_CAMPUS_SUCCESS";
export const GET_CAMPUS_FAILED = "GET_CAMPUS_FAILED";

export const GET_ALL_CAMPUS_SUCCESS = "GET_ALL_CAMPUS_SUCCESS";
export const GET_ALL_CAMPUS_FAILED = "GET_ALL_CAMPUS_FAILED";

export const CREATE_CAMPUS_SUCCESS = "CREATE_CAMPUS_SUCCESS";
export const CREATE_CAMPUS_FAILED = "CREATE_CAMPUS_FAILED";

export const UPDATE_CAMPUS_SUCCESS = "UPDATE_CAMPUS_SUCCESS";
export const UPDATE_CAMPUS_FAILED = "UPDATE_CAMPUS_SUCCESS";

export const DELETE_CAMPUS_SUCCESS = "DELETE_CAMPUS_SUCCESS";
export const DELETE_CAMPUS_FAILED = "DELETE_CAMPUS_FAILED";

export const RESET_CAMPUS_DETAILS = "RESET_CAMPUS_DETAILS";

// Categories
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILED = "GET_CATEGORIES_FAILED";

export const CREATE_CATEGORIES_SUCCESS = "CREATE_CATEGORIES_SUCCESS";
export const CREATE_CATEGORIES_FAILED = "CREATE_CATEGORIES_FAILED";

export const UPDATE_CATEGORIES_SUCCESS = "UPDATE_CATEGORIES_SUCCESS";
export const UPDATE_CATEGORIES_FAILED = "UPDATE_CATEGORIES_SUCCESS";

export const DELETE_CATEGORIES_SUCCESS = "DELETE_CATEGORIES_SUCCESS";
export const DELETE_CATEGORIES_FAILED = "DELETE_CATEGORIES_FAILED";

export const RESET_CATEGORIES_DETAILS = "RESET_TERMS_DETAILS";

export const GET_ALL_CATEGORIES_SUCCESS = "GET_ALL_CATEGORIES_SUCCESS";
export const GET_ALL_CATEGORIES_FAILED = "GET_ALL_CATEGORIES_FAILED";

// lessons
export const GET_LESSON_LIST_SUCCESS = "GET_LESSON_LIST_SUCCESS";
export const GET_LESSON_LIST_FAILED = "GET_LESSON_LIST_FAILED";
export const RESET_LESSON_LIST = "RESET_LESSON_LIST";

export const GET_LESSON_PROGRESS_LIST_SUCCESS =
  "GET_LESSON_PROGRESS_LIST_SUCCESS";
export const GET_LESSON_PROGRESS_LIST_FAILED =
  "GET_LESSON_PROGRESS_LIST_FAILED";
export const RESET_LESSON_PROGRESS_LIST = "RESET_LESSON_PROGRESS_LIST";

export const GET_SPECEFIC_LESSON_PROGRESS_LIST_SUCCESS =
  "GET_SPECEFIC_LESSON_PROGRESS_LIST_SUCCESS";
export const GET_SPECEFIC_LESSON_PROGRESS_LIST_FAILED =
  "GET_SPECEFIC_LESSON_PROGRESS_LIST_FAILED";
export const RESET_SPECEFIC_LESSON_PROGRESS_LIST =
  "RESET_SPECEFIC_LESSON_PROGRESS_LIST";

export const CREATE_LESSON_SUCCESS = "CREATE_LESSON_SUCCESS";
export const CREATE_LESSON_FAILED = "CREATE_LESSON_FAILED";

export const DELETE_LESSON_SUCCESS = "DELETE_LESSON_SUCCESS";
export const DELETE_LESSON_FAILED = "DELETE_LESSON_FAILED";

export const GET_LESSON_DETAILS_SUCCESS = "GET_LESSON_DETAILS_SUCCESS";
export const GET_LESSON_DETAILS_FAILED = "GET_LESSON_DETAILS_FAILED";
export const RESET_UPDATE_LESSON_DETAILS = "RESET_UPDATE_LESSON_DETAILS";
export const RESET_LESSONS_DETAILS = "RESET_LESSONS_DETAILS";
export const RESET_LESSON_BY_COURSE = "RESET_LESSON_BY_COURSE";
export const UPDATE_LESSSON_SUCCESS = "UPDATE_LESSSON_SUCCESS";
export const UPDATE_LESSSON_FAILED = "UPDATE_LESSSON_FAILED";

// lesson content
export const GET_LESSON_CONTENT_SUCCESS = "GET_LESSON_CONTENT_SUCCESS";
export const GET_LESSON_CONTENT_FAILED = "GET_LESSON_CONTENT_FAILED";

export const CREATE_LESSON_CONTENT_SUCCESS = "CREATE_LESSON_CONTENT_SUCCESS";
export const CREATE_LESSON_CONTENT_FAILED = "CREATE_LESSON_CONTENT_FAILED";

export const UPDATE_LESSON_CONTENT_SUCCESS = "UPDATE_LESSON_CONTENT_SUCCESS";
export const UPDATE_LESSON_CONTENT_FAILED = "UPDATE_LESSON_CONTENT_FAILED";

export const UPDATE_LESSON_ORDER_SUCCESS = "UPDATE_LESSON_ORDER_SUCCESS";
export const UPDATE_LESSON_ORDER_FAILED = "UPDATE_LESSON_ORDER_FAILED";

export const DELETE_LESSON_CONTENT_SUCCESS = "DELETE_LESSON_CONTENT_SUCCESS";
export const DELETE_LESSON_CONTENT_FAILED = "DELETE_LESSON_CONTENT_SUCCESS";

export const SET_CURRENT_LESSON_CONTENT = "SET_CURRENT_LESSON_CONTENT";
export const RESET_CURRENT_LESSON_CONTENT = "RESET_CURRENT_LESSON_CONTENT";
export const UPDATE_LESSON_CONTENT_VALUE = "UPDATE_LESSON_CONTENT_VALUE";

export const UPDATE_FILE_URL = "UPDATE_FILE_URL";

//Event-content
export const SET_CURRENT_EVENT_CONTENT = "SET_CURRENT_EVENT_CONTENT";
export const RESET_CURRENT_EVENT_CONTENT = "RESET_CURRENT_EVENT_CONTENT";
export const UPDATE_EVENT_CONTENT_VALUE = "UPDATE_EVENT_CONTENT_VALUE";
export const GET_LESSON_CONTENT_DETAIL_SUCCESS =
  "GET_LESSON_CONTENT_DETAIL_SUCCESS";
export const GET_LESSON_CONTENT_DETAIL_FAILED =
  "GET_LESSON_CONTENT_DETAIL_FAILED";

export const GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_SUCCESS =
  "GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_SUCCESS";
export const GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_FAILED =
  "GET_LESSON_CONTENT_DETAIL_BY_LESSON_ID_FAILED";

export const GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_SUCCESS =
  "GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_SUCCESS";
export const GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_FAILED =
  "GET_LESSON_CONTENT_DETAIL_NEXT_PAGE_FAILED";

export const RESET_LESSON_CONTENT_DETAIL_NEXT_PAGE =
  "RESET_LESSON_CONTENT_DETAIL_NEXT_PAGE";

export const RESET_LESSON_CONTENT_DETAIL = "RESET_LESSON_CONTENT_DETAIL";

export const LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_SUCCESS =
  "LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_SUCCESS";
export const LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_FAILED =
  "LESSON_CONTENT_MARK_COMPLETE_IN_COMPLETE_FAILED";
export const LESSON_STATUS_CHANGE = "LESSON_STATUS_CHANGE";
export const GET_LESSON_PROGRESS_SUCCESS = "GET_LESSON_PROGRESS_SUCCESS";

export const STUDENT_VIEW_CONTENT_LIST_SUCCESS =
  "STUDENT_VIEW_CONTENT_LIST_SUCCESS";
export const STUDENT_VIEW_CONTENT_LIST_FAILED =
  "STUDENT_VIEW_CONTENT_LIST_FAILED";

// Roles
export const GET_USERROLES_SUCCESS = "GET_USERROLES_SUCCESS";
export const GET_USERROLES_FAILED = "GET_USERROLES_FAILED";

//Communities
export const GET_ALL_COMMUNITIES = "GET_ALL_COMMUNITIES";
export const GET_ALL_COMMUNITIES_ERROR = "GET_ALL_COMMUNITIES_ERROR";

export const GET_SINGLE_COMMUNITIES = "GET_SINGLE_COMMUNITIES";
export const GET_SINGLE_COMMUNITIES_ERROR = "GET_SINGLE_COMMUNITIES_ERROR";

export const ADD_ALL_COMMUNITIES = "ADD_ALL_COMMUNITIES";
export const ADD_ALL_COMMUNITIES_ERROR = "ADD_ALL_COMMUNITIES_ERROR";

export const EDIT_ALL_COMMUNITIES = "EDIT_ALL_COMMUNITIES";
export const EDIT_ALL_COMMUNITIES_ERROR = "EDIT_ALL_COMMUNITIES_ERROR";

export const DELETE_ALL_COMMUNITIES = "DELETE_ALL_COMMUNITIES";
export const DELETE_ALL_COMMUNITIES_ERROR = "DELETE_ALL_COMMUNITIES_ERROR";

export const RESET_COMMUNITIES_DETAILS = "RESET_COMMUNITIES_DETAILS";

export const SET_LOCAL_NEW_COMMUNITY = "SET_LOCAL_NEW_COMMUNITY";
export const SET_COMMUNITY_VALUE = "SET_COMMUNITY_VALUE";
export const SET_COMMUNITY_FOR_UPDATE = "SET_COMMUNITY_FOR_UPDATE";

export const GET_ALL_COMMUNITY_LIST_SUCCESS = "GET_ALL_COMMUNITY_LIST_SUCCESS";
export const GET_ALL_COMMUNITY_LIST_FAILED = "GET_ALL_COMMUNITY_LIST_FAILED";

export const RESET_UPDATE_COMMUNITY_DETAILS = "RESET_UPDATE_COMMUNITY_DETAILS";

// Course
export const SET_LOCAL_NEW_COURSE = "SET_LOCAL_NEW_COURSE";
export const SET_COURSE_VALUE = "SET_COURSE_VALUE";

export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const CREATE_COURSE_FAILED = "CREATE_COURSE_FAILED";

export const GET_COURSE_LIST_SUCCESS = "GET_COURSE_LIST_SUCCESS";
export const GET_COURSE_LIST_FAILED = "GET_COURSE_LIST_FAILED";

export const GET_MASTER_COURSE_LIST_SUCCESS = "GET_MASTER_COURSE_LIST_SUCCESS";
export const GET_MASTER_COURSE_LIST_FAILED = "GET_MASTER_COURSE_LIST_FAILED";

export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILED = "DELETE_COURSE_FAILED";

export const GET_ALL_COURSE_LIST_SUCCESS = "GET_ALL_COURSE_LIST_SUCCESS";
export const GET_ALL_COURSE_LIST_FAILED = "GET_ALL_COURSE_LIST_FAILED";

export const GET_COURSE_DETAILS_SUCCESS = "GET_COURSE_DETAILS_SUCCESS";
export const GET_COURSE_DETAILS_FAILED = "GET_COURSE_DETAILS_FAILED";

export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAILED = "UPDATE_COURSE_FAILED";

export const SET_COURSE_FOR_UPDATE = "SET_COURSE_FOR_UPDATE";

export const RESET_COURSE_DETAILS = "RESET_COURSE_DETAILS";
export const RESET_UPDATE_COURSE_DETAILS = "RESET_UPDATE_COURSE_DETAILS";
export const RESET_CURRENT_COURSE_DETAILS = "RESET_CURRENT_COURSE_DETAILS";

//course Syllabus

export const CREATE_COURSE_SYLLABUS_SUCCESS = "CREATE_COURSE_SYLLABUS_SUCCESS";
export const CREATE_COURSE_SYLLABUS_FAILED = "CREATE_COURSE_SYLLABUS_FAILED";

export const GET_COURSE_SYLLABUS_LIST_SUCCESS =
  "GET_COURSE_SYLLABUS_LIST_SUCCESS";
export const GET_COURSE_SYLLABUS_LIST_FAILED =
  "GET_COURSE_SYLLABUS_LIST_FAILED";

//resource
export const GET_RESOURCE_LIST_SUCCESS = "GET_RESOURCE_LIST_SUCCESS";
export const GET_RESOURCE_LIST_FAILED = "GET_RESOURCE_LIST_FAILED";

export const GET_RESOURCE_DROPDOWN_LIST_SUCCESS =
  "GET_RESOURCE_DROPDOWN_LIST_SUCCESS";
export const GET_RESOURCE_DROPDOWN_LIST_FAILED =
  "GET_RESOURCE_DROPDOWN_LIST_FAILED";
export const CREATE_RESOURCE_SUCCESS = "CREATE_RESOURCE_SUCCESS";
export const CREATE_RESOURCE_FAILED = "CREATE_RESOURCE_FAILED";
export const DELETE_RESOURCE_SUCCESS = "DELETE_RESOURCE_SUCCESS";
export const DELETE_RESOURCE_FAILED = "DELETE_RESOURCE_FAILED";

// resource File
export const GET_RESOURCE_FILE_LIST_SUCCESS = "GET_RESOURCE_FILE_LIST_SUCCESS";
export const GET_RESOURCE_FILE_LIST_FAILED = "GET_RESOURCE_FILE_LIST_FAILED";
export const CREATE_SINGLE_RESOURCE_FILE_SUCCESS =
  "CREATE_SINGLE_RESOURCE_FILE_SUCCESS";
export const RESET_RESOURCE_FILE_DETAIL = "RESET_RESOURCE_FILE_DETAIL";
export const RESET_RESOURCES = "RESET_RESOURCES";
export const UPDATE_RESOURCE_FILE_SUCCESS = "UPDATE_RESOURCE_FILE_SUCCESS";
export const UPDATE_RESOURCE_FILE_FAILED = "UPDATE_RESOURCE_FILE_FAILED";

export const SEARCH_RESOURCE_FILE_DETAILS_SUCCESS =
  "SEARCH_RESOURCE_FILE_DETAILS_SUCCESS";
export const SEARCH_RESOURCE_FILE_DETAILS_FAILED =
  "SEARCH_RESOURCE_FILE_DETAILS_FAILED";

export const SET_COURSE_DETAILS = "SET_COURSE_DETAILS";
export const SET_COURSE_DETAILS_FAILED = "SET_COURSE_DETAILS_FAILED";

// Bulk file List
export const SET_BULK_FILE_LIST = "SET_BULK_FILE_LIST";
export const SET_BULK_UPLOAD_FILE_PROGRESS = "SET_BULK_UPLOAD_FILE_PROGRESS";
export const DELETE_BULK_UPLOAD_FILE = "DELETE_BULK_UPLOAD_FILE";
export const RESET_BULK_UPLOAD_FILE_LIST = "RESET_BULK_UPLOAD_FILE_LIST";

// resource Question
export const GET_RESOURCE_QUESTIN_LIST_SUCCESS =
  "GET_RESOURCE_QUESTIN_LIST_SUCCESS";
export const GET_RESOURCE_QUESTIN_LIST_FAILED =
  "GET_RESOURCE_QUESTIN_LIST_FAILED";
export const SET_NEW_LOCAL_QUESTION = "SET_NEW_LOCAL_QUESTION";
export const UPDATE_NEW_LOCAL_QUESTION = "UPDATE_NEW_LOCAL_QUESTION";
export const UPDATE_NEW_LOCAL_QUESTION_OPTIONS =
  "UPDATE_NEW_LOCAL_QUESTION_OPTIONS";

export const CREATE_RESOURCE_QUESTION_SUCCESS =
  "CREATE_RESOURCE_QUESTION_SUCCESS";
export const CREATE_RESOURCE_QUESTION_FAILED =
  "CREATE_RESOURCE_QUESTION_FAILED";

export const DELETE_RESOURCE_QUESTION_SUCCESS =
  "DELETE_RESOURCE_QUESTION_SUCCESS";
export const DELETE_RESOURCE_QUESTION_FAILED =
  "DELETE_RESOURCE_QUESTION_FAILED";

export const UPDATE_RESOURCE_QUESTION_SUCCESS =
  "UPDATE_RESOURCE_QUESTION_SUCCESS";

export const UPDATE_RESOURCE_QUESTION_FAILED =
  "UPDATE_RESOURCE_QUESTION_FAILED";

export const MOVE_QUESTION_SUCCESS = "MOVE_QUESTION_SUCCESS";
export const MOVE_QUESTION_FAILED = "MOVE_QUESTION_FAILED";

export const ADD_NEW_QUESTION_OPTIONS = "ADD_NEW_QUESTION_OPTIONS";
export const RESET_NEW_CURRENT_QUESTIONS = "RESET_NEW_CURRENT_QUESTIONS";

export const DELETE_RESOURCE_FILE_SUCCESS = "DELETE_RESOURCE_FILE_SUCCESS";
export const DELETE_RESOURCE_FILE_FAILED = "DELETE_RESOURCE_FILE_FAILED";

export const UPDATE_RESOURCE_SUCCESS = "UPDATE_RESOURCE_SUCCESS";
export const UPDATE_RESOURCE_FAILED = "UPDATE_RESOURCE_FAILED";

//user actions
export const USER_ACTION_SUCCESS = "USER_ACTION_SUCCESS";
export const USER_ACTION_ERROR = "USER_ACTION_ERROR";

//setting
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILED = "GET_SETTINGS_FAILED";
export const SET_SETTINGS = "SET_SETTINGS";

export const GET_USER_DETAILS_ID_SUCCESS = "GET_USER_DETAILS_ID_SUCCESS";
export const GET_USER_DETAILS_ID_FAILED = "GET_USER_DETAILS_ID_FAILED";
export const RESET_USER_DETAILS_ID = "RESET_USER_DETAILS_ID";

export const EDIT_SETTINGS_SUCCESS = "EDIT_SETTINGS_SUCCESS";
export const EDIT_SETTINGS_FAILED = "EDIT_SETTINGS_FAILED";

//Discussion Forum
export const GET_DISCUSSION_FORUM = "GET_DISCUSSION_FORUM";
export const GET_DISCUSSION_FORUM_ERROR = "GET_DISCUSSION_FORUM_ERROR";

export const GET_SINGLE_DISCUSSION_FORUM = "GET_SINGLE_DISCUSSION_FORUM";
export const GET_SINGLE_DISCUSSION_FORUM_ERROR =
  "GET_SINGLE_DISCUSSION_FORUM_ERROR";

export const GET_DISCUSSION_FORUM_NAME = "GET_DISCUSSION_FORUM_NAME";
export const GET_DISCUSSION_FORUM_NAME_ERROR =
  "GET_DISCUSSION_FORUM_NAME_ERROR";

export const ADD_DISCUSSION_FORUM = "ADD_DISCUSSION_FORUM";
export const ADD_DISCUSSION_FORUM_ERROR = "ADD_DISCUSSION_FORUM_ERROR";

export const EDIT_DISCUSSION_FORUM = "EDIT_DISCUSSION_FORUM";
export const EDIT_DISCUSSION_FORUM_ERROR = "EDIT_DISCUSSION_FORUM_ERROR";

export const DELETE_DISCUSSION_FORUM = "DELETE_DISCUSSION_FORUM";
export const DELETE_DISCUSSION_FORUM_ERROR = "DELETE_DISCUSSION_FORUM_ERROR";

export const RESET_DISCUSSION_DETAILS_FORUM = "RESET_DISCUSSION_DETAILS_FORUM";

export const RESET_UPDATE_DISCUSSION_DETAILS =
  "RESET_UPDATE_DISCUSSION_DETAILS";

//Discussion Post
export const GET_DISCUSSION_POST = "GET_DISCUSSION_POST";
export const GET_DISCUSSION_POST_ERROR = "GET_DISCUSSION_POST_ERROR";

export const GET_SINGLE_DISCUSSION_POST = "GET_SINGLE_DISCUSSION_POST";
export const GET_SINGLE_DISCUSSION_POST_ERROR =
  "GET_SINGLE_DISCUSSION_POST_ERROR";

export const GET_DISCUSSION_POST_NAME = "GET_DISCUSSION_POST_NAME";
export const GET_DISCUSSION_POST_NAME_ERROR = "GET_DISCUSSION_POST_NAME_ERROR";

export const ADD_DISCUSSION_POST = "ADD_DISCUSSION_POST";
export const ADD_DISCUSSION_POST_ERROR = "ADD_DISCUSSION_POST_ERROR";

export const ADD_DISCUSSION_FOR_POST = "ADD_DISCUSSION_FOR_POST";
export const ADD_DISCUSSION_FOR_POST_ERROR = "ADD_DISCUSSION_FOR_POST_ERROR";

export const EDIT_DISCUSSION_POST = "EDIT_DISCUSSION_POST";
export const EDIT_DISCUSSION_POST_ERROR = "EDIT_DISCUSSION_POST_ERROR";

export const EDIT_DISCUSSION_FOR_POST = "EDIT_DISCUSSION_FOR_POST";
export const EDIT_DISCUSSION_FOR_POST_ERROR = "EDIT_DISCUSSION_FOR_POST_ERROR";

export const DELETE_DISCUSSION_POST = "DELETE_DISCUSSION_POST";
export const DELETE_DISCUSSION_POST_ERROR = "DELETE_DISCUSSION_POST_ERROR";

export const DELETE_DISCUSSION_FOR_POST = "DELETE_DISCUSSION_FOR_POST";
export const DELETE_DISCUSSION_FOR_POST_ERROR =
  "DELETE_DISCUSSION_FOR_POST_ERROR";

export const RESET_DISCUSSION_DETAILS_POST = "RESET_DISCUSSION_DETAILS_POST";

export const RESET_UPDATE_DISCUSSION_FORUM_DETAILS =
  "RESET_UPDATE_DISCUSSION_FORUM_DETAILS";
//reset password
export const RESET_PASSWORD_SUCCESS = " RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = " RESET_PASSWORD_FAILED";

export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWWORD_FAILED = "FORGET_PASSWWORD_FAILED";
export const RESET_FORGET_PASSWORD = "RESET_FORGET_PASSWORD";

export const VALIDATE_PASSWORD_SUCCESS = "VALIDATE_PASSWORD_SUCCESS";
export const VALIDATE_PASSWORD_FAILED = "VALIDATE_PASSWORD_FAILED";
export const RESET_VALIDATE_PASSWORD = "RESET_VALIDATE_PASSWORD";

export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const RESET_UPDATE_PASSWORD_SUCCESS = "RESET_UPDATE_PASSWORD_SUCCESS";

export const GET_SINGLE_POST = "GET_SINGLE_POST";
export const GET_SINGLE_POST_ERROR = "GET_SINGLE_POST_ERROR";

export const GET_SINGLE_FORUM = "GET_SINGLE_FORUM";
export const GET_SINGLE_FORUM_ERROR = "GET_SINGLE_FORUM_ERROR";

//surveys
export const GET_SURVEYS_SUCCESS = "GET_SURVEYS_SUCCESS";
export const GET_SURVEYS_FAILED = "GET_SURVEYS_FAILED";

export const CREATE_SURVEY_SUCCESS = "CREATE_SURVEY_SUCCESS";
export const CREATE_SURVEY_FAILED = "CREATE_SURVEY_FAILED";

export const DELETE_SURVEY_SUCCESS = "DELETE_SURVEY_SUCCESS";
export const DELETE_SURVEY_FAILED = "DELETE_SURVEY_FAILED";

export const GET_SURVEY_DETAILS_SUCCESS = "GET_SURVEY_DETAILS_SUCCESS";
export const GET_SURVEY_DETAILS_FAILED = "GET_SURVEY_DETAILS_FAILED";

export const RESET_UPDATE_SURVEY_DETAILS = "RESET_UPDATE_SURVEY_DETAILS";
export const RESET_SURVEYS_DETAILS = "RESET_SURVEYS_DETAILS";

export const UPDATE_SURVEY_SUCCESS = "UPDATE_SURVEY_SUCCESS";
export const UPDATE_SURVEY_FAILED = "UPDATE_SURVEY_FAILED";

export const CREATE_DUPLIACTE_SURVEY_SUCCESS =
  "CREATE_DUPLIACTE_SURVEY_SUCCESS";
export const CREATE_DUPLIACTE_SURVEY_FAILED = "CREATE_DUPLIACTE_SURVEY_FAILED";

//survey preview
export const GET_SURVEYS_PREVIEW_SUCCESS = "GET_SURVEYS_PREVIEW_SUCCESS";
export const GET_SURVEYS_PREVIEW_ERROR = "GET_SURVEYS_PREVIEW_ERROR";
export const POST_SURVEY_SUCCESS = "POST_SURVEY_SUCCESS";
export const POST_SURVEY_ERROR = "POST_SURVEY_ERROR";

//survey questions
export const GET_SURVEY_QUESTIONS_SUCCESS = "GET_SURVEY_QUESTIONS_SUCCESS";
export const GET_SURVEY_QUESTIONS_FAILED = "GET_SURVEY_QUESTIONS_FAILED";

export const CREATE_SURVEY_QUESTIONS_SUCCESS =
  "CREATE_SURVEY_QUESTIONS_SUCCESS";
export const CREATE_SURVEY_QUESTIONS_FAILED = "CREATE_SURVEY_QUESTIONS_FAILED";

export const CREATE_SURVEY_ANSWER_SUCCESS = "CREATE_SURVEY_ANSWER_SUCCESS";
export const CREATE_SURVEY_ANSWER_FAILED = "CREATE_SURVEY_ANSWER_FAILED";

export const GET_SURVEY_ANSWER_SUCCESS = "GET_SURVEY_ANSWER_SUCCESS";
export const GET_SURVEY_ANSWER_FAILED = "GET_SURVEY_ANSWER_FAILED";

export const DELETE_SURVEY_QUESTIONS_SUCCESS =
  "DELETE_SURVEY_QUESTIONS_SUCCESS";
export const DELETE_SURVEY_QUESTIONS_FAILED = "DELETE_SURVEY_QUESTIONS_FAILED";

export const GET_SURVEY_QUESTIONS_DETAILS_SUCCESS =
  "GET_SURVEY_QUESTIONS_DETAILS_SUCCESS";
export const GET_SURVEY_QUESTIONS_DETAILS_FAILED =
  "GET_SURVEY_QUESTIONS_DETAILS_FAILED";

export const RESET_UPDATE_SURVEY_QUESTIONS_DETAILS =
  "RESET_UPDATE_SURVEY_QUESTIONS_DETAILS";
export const RESET_SURVEY_QUESTIONS_DETAILS = "RESET_SURVEY_QUESTIONS_DETAILS";

export const UPDATE_SURVEY_QUESTIONS_SUCCESS =
  "UPDATE_SURVEY_QUESTIONS_SUCCESS";
export const UPDATE_SURVEY_QUESTIONS_FAILED = "UPDATE_SURVEY_QUESTIONS_FAILED";

export const RESET_SURVEY_SUCCESS = "RESET_SURVEY_SUCCESS";
export const RESET_SURVEY_FAILED = "RESET_SURVEY_FAILED";

export const SET_LOCAL_NEW_SURVEY = "SET_LOCAL_NEW_SURVEY";
export const SET_SURVEY_VALUE = "SET_SURVEY_VALUE";
export const SET_SURVEY_FOR_UPDATE = "SET_SURVEY_FOR_UPDATE";

export const ENROLL_TO_SURVEY_SUCCESS = "ENROLL_TO_SURVEY_SUCCESS";
export const ENROLL_TO_SURVEY_FAILED = "ENROLL_TO_SURVEY_FAILED";

export const EXCLUDE_FROM_SURVEY_SUCCESS = "EXCLUDE_FROM_SURVEY_SUCCESS";
export const EXCLUDE_FROM_SURVEY_FAILED = "EXCLUDE_FROM_SURVEY_FAILED";

// Test Constants
export const CREATE_TEST_SUCCESS = "CREATE_TEST_SUCCESS";
export const CREATE_TEST_FAILED = "CREATE_TEST_FAILED";

export const GET_TEST_LIST_SUCCESS = "GET_TEST_LIST_SUCCESS";
export const GET_TEST_LIST_FAILED = "GET_TEST_LIST_FAILED";

export const DELETE_TEST_SUCCESS = "DELETE_TEST_SUCCESS";
export const DELETE_TEST_FAILED = "DELETE_TEST_FAILED";

export const GET_ALL_TEST_LIST_SUCCESS = "GET_ALL_TEST_LIST_SUCCESS";
export const GET_ALL_TEST_LIST_FAILED = "GET_ALL_TEST_LIST_FAILED";

export const GET_TEST_DETAILS_SUCCESS = "GET_TEST_DETAILS_SUCCESS";
export const GET_TEST_DETAILS_FAILED = "GET_TEST_DETAILS_FAILED";

export const UPDATE_TEST_SUCCESS = "UPDATE_TEST_SUCCESS";
export const UPDATE_TEST_FAILED = "UPDATE_TEST_FAILED";

export const SAVE_INSTRUCTIONSAUDIO_REQUEST = "SAVE_INSTRUCTIONSAUDIO_REQUEST";
export const SAVE_INSTRUCTIONSAUDIO_SUCCESS = "SAVE_INSTRUCTIONSAUDIO_SUCCESS";
export const SAVE_INSTRUCTIONSAUDIO_FAILED = "SAVE_INSTRUCTIONSAUDIO_FAILED";

export const ADD_TEST_QUESTION_SUCCESS = "ADD_TEST_QUESTION_SUCCESS";
export const ADD_TEST_QUESTION_FAILED = "ADD_TEST_QUESTION_FAILED";

export const DELETE_TEST_QUESTION_SUCCESS = "DELETE_TEST_QUESTION_SUCCESS";
export const DELETE_TEST_QUESTION_FAILED = "DELETE_TEST_QUESTION_FAILED";

export const GET_TEST_QUESTION_LIST_SUCCESS = "GET_TEST_QUESTION_LIST_SUCCESS";
export const GET_TEST_QUESTION_LIST_FAILED = "GET_TEST_QUESTION_LIST_FAILED";

export const START_TEST_SUCCESS = "START_TEST_SUCCESS";
export const START_TEST_FAILED = "START_TEST_FAILED";

export const FINISH_TEST_SUCCESS = "FINISH_TEST_SUCCESS";
export const FINISH_TEST_FAILED = "FINISH_TEST_FAILED";
export const FINISH_TEST_RESET = "FINISH_TEST_RESET";
export const RESET_TEST_SUCCESS = "RESET_TEST_SUCCESS";
export const RESET_TEST_FAILED = "RESET_TEST_FAILED";
export const RESET_TESTS = "RESET_TESTS";
export const RESET_TESTS_BY_COURSE = "RESET_TESTS_BY_COURSE";
export const GET_TEST_TRACKER_SUCCESS = "GET_TEST_TRACKER_SUCCESS";
export const GET_TEST_TRACKER_FAILED = "GET_TEST_TRACKER_FAILED";

export const DELETE_TRACKER_SUCCESS = "DELETE_TRACKER_SUCCESS";
export const DELETE_TRACKER_FAILED = "DELETE_TRACKER_FAILED";

export const RESET_TEST_DETAILS = "RESET_TEST_DETAILS";

export const DUPLICATE_TEST_SUCCESS = "DUPLICATE_TEST_SUCCESS";
export const DUPLICATE_TEST_FAILED = "DUPLICATE_TEST_FAILED";

export const UPDATE_TEST_TRACKER_SUCCESS = "UPDATE_TEST_TRACKER_SUCCESS";
export const UPDATE_TEST_TRACKER_FAILED = "UPDATE_TEST_TRACKER_FAILED";

//DropBox
export const CREATE_DROPBOX_SUCCESS = "CREATE_DROPBOX_SUCCESS";
export const CREATE_DROPBOX_FAILED = "CREATE_DROPBOX_FAILED";

export const GET_DROPBOX_LIST_SUCCESS = "GET_DROPBOX_LIST_SUCCESS";
export const GET_DROPBOX_LIST_FAILED = "GET_DROPBOX_LIST_FAILED";

export const GET_SINGLE_DROPBOX_LIST_SUCCESS =
  "GET_SINGLE_DROPBOX_LIST_SUCCESS";
export const GET_SINGLE_DROPBOX_LIST_FAILED = "GET_SINGLE_DROPBOX_LIST_FAILED";

export const DELETE_DROPBOX_SUCCESS = "DELETE_DROPBOX_SUCCESS";
export const DELETE_DROPBOX_FAILED = "DELETE_DROPBOX_FAILED";

export const EDIT_DROPBOX_SUCCESS = "EDIT_DROPBOX_SUCCESS";
export const EDIT_DROPBOX_FAILED = "EDIT_DROPBOX_FAILED";

export const RESET_DROPBOX_DETAILS = "RESET_DROPBOX_DETAILS";
//dropbox file
export const SET_BULK_FILE_LIST_DROPBOX = "SET_BULK_FILE_LIST_DROPBOX";
export const SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX =
  "SET_BULK_UPLOAD_FILE_PROGRESS_DROPBOX";
export const DELETE_BULK_UPLOAD_FILE_DROPBOX =
  "DELETE_BULK_UPLOAD_FILE_DROPBOX";

export const DELETE_DROPBOX_FILE_SUCCESS = "DELETE_DROPBOX_FILE_SUCCESS";
export const DELETE_DROPBOX_FILE_FAILED = "DELETE_DROPBOX_FILE_FAILED";
export const RESET_DROPBOX_FILE_DETAIL = "RESET_DROPBOX_FILE_DETAIL";

export const GET_DROPBOX_FILE_LIST_SUCCESS = "GET_DROPBOX_FILE_LIST_SUCCESS";
export const GET_DROPBOX_FILE_LIST_FAILED = "GET_DROPBOX_FILE_LIST_FAILED";
export const CREATE_SINGLE_DROPBOX_FILE_SUCCESS =
  "CREATE_SINGLE_DROPBOX_FILE_SUCCESS";
export const UPDATE_DROPBOX_FILE_SUCCESS = "UPDATE_DROPBOX_FILE_SUCCESS";
export const UPDATE_DROPBOX_FILE_FAILED = "UPDATE_DROPBOX_FILE_FAILED";

export const SEARCH_DROPBOX_FILE_DETAILS_SUCCESS =
  "SEARCH_DROPBOX_FILE_DETAILS_SUCCESS";
export const SEARCH_DROPBOX_FILE_DETAILS_FAILED =
  "SEARCH_DROPBOX_FILE_DETAILS_FAILED";

//calendar
export const CREATE_CALENDAR_SUCCESS = "CREATE_CALENDAR_SUCCESS";
export const CREATE_CALENDAR_FAILED = "CREATE_CALENDAR_FAILED";

export const GET_CALENDAR_SUCCESS = "GET_CALENDAR_SUCCESS";
export const GET_CALENDAR_FAILED = "GET_CALENDAR_FAILED";

export const GET_CALENDAR_EVENT_SUCCESS = "GET_CALENDAR_EVENT_SUCCESS";
export const GET_CALENDAR_EVENT_FAILED = "GET_CALENDAR_EVENT_FAILED";

export const GET_CALENDAR_EVENT_RESOURCE_SUCCESS =
  "GET_CALENDAR_EVENT_RESOURCE_SUCCESS";
export const GET_CALENDAR_EVENT_RESOURCE_FAILED =
  "GET_CALENDAR_EVENT_RESOURCE_FAILD";

export const DELETE_CALENDAR_SUCCESS = "DELETE_CALENDAR_SUCCESS";
export const DELETE_CALENDAR_FAILED = "DELETE_CALENDAR_FAILED";

export const UPDATE_CALENDAR_EVENT_SUCCESS = "UPDATE_CALENDAR_EVENT_SUCCESS";
export const UPDATE_CALENDAR_EVENT_FAILED = "UPDATE_CALENDAR_EVENT_FAILED";

export const UPDATE_CALENDAR_RSVP_EVENT_SUCCESS =
  "UPDATE_CALENDAR_RSVP_EVENT_SUCCESS";
export const UPDATE_CALENDAR_RSVP_EVENT_FAILED =
  "UPDATE_CALENDAR_RSVP_EVENT_FAILED";

export const GET_RSVP_SUCCESS = "GET_RSVP_SUCCESS";
export const GET_RSVP_FAILED = "GET_RSVP_FAILED";

export const GET_RSVP_BY_CALENDAR_SUCCESS = "GET_RSVP_BY_CALENDAR_SUCCESS";
export const GET_RSVP_BY_CALENDAR_FAILED = "GET_RSVP_BY_CALENDAR_FAILED";

export const CREATE_RSVP_SUCCESS = "CREATE_RSVP_SUCCESS";
export const CREATE_RSVP_FAILED = "CREATE_RSVP_FAILED";

export const UPDATE_RSVP_SUCCESS = "UPDATE_RSVP_SUCCESS";
export const UPDATE_RSVP_FAILED = "UPDATE_RSVP_FAILED";

export const EVENT_ACTION_SUCCESS = "EVENT_ACTION_SUCCESS";
export const EVENT_ACTION_FAILED = "EVENT_ACTION_FAILED";

export const UPDATE_ATTENDEE_STATUS_SUCCESS = "UPDATE_ATTENDEE_STATUS_SUCCESS";
export const UPDATE_ATTENDEE_DATA_SUCCESS = "UPDATE_ATTENDEE_DATA_SUCCESS";
export const UPDATE_ATTENDEE_STATUS_ERROR = "UPDATE_ATTENDEE_STATUS_ERROR";

//Course Attendees
export const CREATE_ATTENDEE_SUCCESS = "CREATE_ATTENDEE_SUCCESS";
export const CREATE_ATTENDEE_FAILED = "CREATE_ATTENDEE_FAILED";

export const DELETE_ATTENDEE_SUCCESS = "DELETE_ATTENDEE_SUCCESS";
export const DELETE_ATTENDEE_FAILED = "DELETE_ATTENDEE_FAILED";

export const DELETE_MANY_ATTENDEES_SUCCESS = "DELETE_MANY_ATTENDEES_SUCCESS";
export const DELETE_MANY_ATTENDEES_FAILED = "DELETE_MANY_ATTENDEES_FAILED";

export const GET_ATTENDEE_SUCCESS = "GET_ATTENDEE_SUCCESS";
export const GET_ATTENDEE_FAILED = "GET_ATTENDEE_FAILED";

export const GET_COURSE_ATTENDEES_DETAILS = "GET_COURSE_ATTENDEES_DETAILS";
export const GET_COURSE_ATTENDEES_SUCCESS = "GET_COURSE_ATTENDEES_SUCCESS";
export const GET_COURSE_ATTENDEES_FAILED = "GET_COURSE_ATTENDEES_FAILED";

export const GET_COURSE_USER_DETAIL_LIST_SUCCESS =
  "GET_COURSE_USER_DETAIL_LIST_SUCCESS";
export const GET_COURSE_USER_DETAIL_LIST_FAILED =
  "GET_COURSE_USER_DETAIL_LIST_FAILED";
export const RESET_COURSE_USER_DETAIL_LIST_SUCCESS =
  "RESET_COURSE_USER_DETAIL_LIST_SUCCESS";

//dropbox feedback
export const ADD_DROPBOX_FEEDBACK = "ADD_DROPBOX_FEEDBACK";
export const ADD_DROPBOX_FEEDBACK_ERROR = "ADD_DROPBOX_FEEDBACK_ERROR";

export const GET_DROPBOX_FEEDBACK = "GET_DROPBOX_FEEDBACK";
export const GET_DROPBOX_FEEDBACK_ERROR = "GET_DROPBOX_FEEDBACK_ERROR";

export const GET_DROPBOX_DETAILS_USER = "GET_DROPBOX_DETAILS_USER";
export const GET_DROPBOX_DETAILS_USER_ERROR = "GET_DROPBOX_DETAILS_USER_ERROR";

//discussion post
export const GET_FORUM_POST_SUCCESS = "GET_FORUM_POST_SUCCESS";
export const GET_FORUM_POST_ERROR = "GET_FORUM_POST_ERROR";

export const GET_ALL_POST_DISCUSSION_SUCCESS =
  "GET_ALL_POST_DISCUSSION_SUCCESS";
export const GET_ALL_POST_DISCUSSION_ERROR = "GET_ALL_POST_DISCUSSION_ERROR";

//post comments
export const ADD_POST_COMMENT_SUCCESS = "ADD_POST_COMMENT_SUCCESS";
export const ADD_POST_COMMENT_ERROR = "ADD_POST_COMMENT_ERROR";

export const GET_POST_COMMENT_SUCCESS = "GET_POST_COMMENT_SUCCESS";
export const GET_POST_COMMENT_ERROR = "GET_POST_COMMENT_ERROR";

export const EDIT_POST_COMMENT_SUCCESS = "EDIT_POST_COMMENT_SUCCESS";
export const EDIT_POST_COMMENT_ERROR = "EDIT_POST_COMMENT_ERROR";

export const DELETE_POST_COMMENT_SUCCESS = "DELETE_POST_COMMENT_SUCCESS";
export const DELETE_POST_COMMENT_ERROR = "DELETE_POST_COMMENT_ERROR";

export const GET_SINGLE_POST_COMMENT_SUCCESS =
  "GET_SINGLE_POST_COMMENT_SUCCESS";
export const GET_SINGLE_POST_COMMENT_ERROR = "GET_SINGLE_POST_COMMENT_ERROR";

export const GET_ALL_DISCUSSION_FORUM_SUCESS =
  "GET_ALL_DISCUSSION_FORUM_SUCESS";
export const GET_ALL_DISCUSSION_FORUM_ERROR = "GET_ALL_DISCUSSION_FORUM_ERROR";

//Announcemet alert admin
export const CREATE_ANNOUNCEMENT_ALERT_SUCCESS =
  "CREATE_ANNOUNCEMENT_ALERT_SUCCESS";
export const CREATE_ANNOUNCEMENT_ALERT_FAILED =
  "CREATE_ANNOUNCEMENT_ALERT_FAILED";

export const DELETE_ANNOUNCEMENT_ALERT_SUCCESS =
  "DELETE_ANNOUNCEMENT_ALERT_SUCCESS";
export const DELETE_ANNOUNCEMENT_ALERT_FAILED =
  "DELETE_ANNOUNCEMENT_ALERT_FAILED";

export const GET_ANNOUNCEMENT_ALERT_SUCCESS = "GET_ANNOUNCEMENT_ALERT_SUCCESS";
export const GET_ANNOUNCEMENT_ALERT_FAILED = "GET_ANNOUNCEMENT_ALERT_FAILED";

export const GET_ANNOUNCEMENT_DETAIL_ALERT_SUCCESS =
  "GET_ANNOUNCEMENT_DETAIL_ALERT_SUCCESS";
export const GET_ANNOUNCEMENT_DETAIL_ALERT_FAILED =
  "GET_ANNOUNCEMENT_DETAIL_ALERT_FAILED";

export const GET_ANNOUNCEMENT_USER_DETAIL_ALERT_SUCCESS =
  "GET_ANNOUNCEMENT_USER_DETAIL_ALERT_SUCCESS";
export const GET_ANNOUNCEMENT_USER_DETAIL_ALERT_FAILED =
  "GET_ANNOUNCEMENT_USER_DETAIL_ALERT_FAILED";

export const UPDATE_ANNOUNCEMENT_ALERT_SUCCESS =
  "UPDATE_ANNOUNCEMENT_ALERT_SUCCESS";
export const UPDATE_ANNOUNCEMENT_ALERT_FAILED =
  "UPDATE_ANNOUNCEMENT_ALERT_FAILED";

export const RESET_UPDATE_ANNOUNCEMENT_ALERT_DETAILS =
  "RESET_UPDATE_ANNOUNCEMENT_ALERT_DETAILS";

export const READ_ANNOUNCEMENT_ALERT_SUCCESS =
  "READ_ANNOUNCEMENT_ALERT_SUCCESS";
export const READ_ANNOUNCEMENT_ALERT_FAILED = "READ_ANNOUNCEMENT_ALERT_FAILED";
//Announcemet
export const CREATE_ANNOUNCEMENT_SUCCESS = "CREATE_ANNOUNCEMENT_SUCCESS";
export const CREATE_ANNOUNCEMENT_FAILED = "CREATE_ANNOUNCEMENT_FAILED";

export const DELETE_ANNOUNCEMENT_SUCCESS = "DELETE_ANNOUNCEMENT_SUCCESS";
export const DELETE_ANNOUNCEMENT_FAILED = "DELETE_ANNOUNCEMENT_FAILED";

export const GET_ANNOUNCEMENT_SUCCESS = "GET_ANNOUNCEMENT_SUCCESS";
export const GET_ANNOUNCEMENT_FAILED = "GET_ANNOUNCEMENT_FAILED";

export const GET_ANNOUNCEMENT_DETAIL_SUCCESS =
  "GET_ANNOUNCEMENT_DETAIL_SUCCESS";
export const GET_ANNOUNCEMENT_DETAIL_FAILED = "GET_ANNOUNCEMENT_DETAIL_FAILED";

export const UPDATE_ANNOUNCEMENT_SUCCESS = "UPDATE_ANNOUNCEMENT_SUCCESS";
export const UPDATE_ANNOUNCEMENT_FAILED = "UPDATE_ANNOUNCEMENT_FAILED";

export const RESET_UPDATE_ANNOUNCEMENT_DETAILS =
  "RESET_UPDATE_ANNOUNCEMENT_DETAILS";

export const READ_ANNOUNCEMENT_SUCCESS = "READ_ANNOUNCEMENT_SUCCESS";
export const READ_ANNOUNCEMENT_FAILED = "READ_ANNOUNCEMENT_FAILED";
// Dropdown Data

export const GET_COURSE_USER_LIST_REQUEST = "GET_COURSE_USER_LIST_REQUEST";
export const GET_COURSE_USER_LIST_SUCCESS = "GET_COURSE_USER_LIST_SUCCESS";
export const GET_COURSE_USER_LIST_FAILED = "GET_COURSE_USER_LIST_FAILED";

export const GET_RESOURCE_USER_REQUEST = "GET_RESOURCE_USER_REQUEST";
export const GET_RESOURCE_USER_REQUEST_SUCCESS =
  "GET_RESOURCE_USER_REQUEST_SUCCESS";
export const GET_RESOURCE_USER_REQUEST_FAILED =
  "GET_RESOURCE_USER_REQUEST_FAILED";

export const GET_RESOURCE_FILE_REQUEST = "GET_RESOURCE_FILE_REQUEST";
export const GET_RESOURCE_FILE_REQUEST_SUCCESS =
  "GET_RESOURCE_FILE_REQUEST_SUCCESS";
export const GET_RESOURCE_FILE_REQUEST_FAILED =
  "GET_RESOURCE_FILE_REQUEST_FAILED";

export const GET_DISCUSSION_FORUM_LIST = "GET_DISCUSSION_FORUM_LIST";
export const GET_DISCUSSION_FORUM_LIST_SUCCESS =
  "GET_DISCUSSION_FORUM_LIST_SUCCESS";
export const GET_DISCUSSION_FORUM_LIST_FAILED =
  "GET_DISCUSSION_FORUM_LIST_FAILED";

export const GET_LESSON_DROPBOX_LIST = "GET_LESSON_DROPBOX_LIST";
export const GET_LESSON_DROPBOX_LIST_SUCCESS =
  "GET_LESSON_DROPBOX_LIST_SUCCESS";
export const GET_LESSON_DROPBOX_LIST_FAILED = "GET_LESSON_DROPBOX_LIST_FAILED";

export const GET_LESSON_SURVEY_LIST = "GET_LESSON_SURVEY_LIST";
export const GET_LESSON_SURVEY_LIST_SUCCESS = "GET_LESSON_SURVEY_LIST_SUCCESS";
export const GET_LESSON_SURVEY_LIST_FAILED = "GET_LESSON_SURVEY_LIST_FAILED";

export const GET_LESSON_TEST_LIST = "GET_LESSON_TEST_LIST";
export const GET_LESSON_TEST_LIST_SUCCESS = "GET_LESSON_TEST_LIST_SUCCESS";
export const GET_LESSON_TEST_LIST_FAILED = "GET_LESSON_TEST_LIST_FAILED";

export const GET_LESSON_POST_LIST = "GET_LESSON_POST_LIST";
export const GET_LESSON_POST_LIST_SUCCESS = "GET_LESSON_POST_LIST_SUCCESS";
export const GET_LESSON_POST_LIST_FAILED = "GET_LESSON_POST_LIST_FAILED";

export const GET_COURSE_SYLLABUS_RESOURCE = "GET_COURSE_SYLLABUS_RESOURCE";
export const GET_COURSE_SYLLABUS_RESOURCE_SUCCESS =
  "GET_COURSE_SYLLABUS_RESOURCE_SUCCESS";
export const GET_COURSE_SYLLABUS_RESOURCE_FAILED =
  "GET_COURSE_SYLLABUS_RESOURCE_FAILED";

//Mailbox
export const CREATE_MAIL_SUCCESS = "CREATE_MAIL_SUCCESS";
export const CREATE_MAIL_FAILED = "CREATE_MAIL_FAILED";

export const EDIT_MAIL_SUCCESS = "EDIT_MAIL_SUCCESS";
export const EDIT_MAIL_FAILED = "EDIT_MAIL_FAILED";

export const DELETE_MAIL_SUCCESS = "DELETE_MAIL_SUCCESS";
export const DELETE_MAIL_FAILED = "DELETE_MAIL_FAILED";

export const RESET_MAIL_DETAILS = "RESET_MAIL_DETAILS";
export const RESET_MAILBOX_FOLDER = "RESET_MAILBOX_FOLDER";

export const GET_ALL_MAIL_SUCCESS = "GET_ALL_MAIL_SUCCESS";
export const GET_ALL_MAIL_FAILED = "GET_ALL_MAIL_FAILED";

export const GET_MAIL_ID_SUCCESS = "GET_MAIL_ID_SUCCESS";
export const GET_MAIL_ID_FAILED = "GET_MAIL_ID_FAILED";
export const RESET_SINGLE_MAIL = "RESET_SINGLE_MAIL";
export const CREATE_MAIL_FOLDER_SUCCESS = "CREATE_MAIL_FOLDER_SUCCESS";
export const CREATE_MAIL_FOLDER_FAILED = "CREATE_MAIL_FOLDER_FAILED";

export const CREATE_EMAIL_TEMPLATE_SUCCESS = "CREATE_EMAIL_TEMPLATE_SUCCESS";
export const CREATE_EMAIL_TEMPLATE_FAILED = "CREATE_EMAIL_TEMPLATE_FAILED";

export const GET_EMAIL_TEMPLATE_SUCCESS = "GET_EMAIL_TEMPLATE_SUCCESS";
export const GET_EMAIL_TEMPLATE_FAILED = "GET_EMAIL_TEMPLATE_FAILED";

export const DELETE_EMAIL_TEMPLATE_SUCCESS = "DELETE_EMAIL_TEMPLATE_SUCCESS";
export const DELETE_EMAIL_TEMPLATE_FAILED = "DELETE_EMAIL_TEMPLATE_FAILED";

export const GET_ALL_MAIL_FOLDER_SUCCESS = "GET_ALL_MAIL_FOLDER_SUCCESS";
export const GET_ALL_MAIL_FOLDER_FAILED = "GET_ALL_MAIL_FOLDER_FAILED";

export const DELETE_MAIL_FOLDER_SUCCESS = "DELETE_MAIL_FOLDER_SUCCESS";
export const DELETE_MAIL_FOLDER_FAILED = "DELETE_MAIL_FOLDER_FAILED";

export const SET_LOCAL_NEW_EMAIL = "SET_LOCAL_NEW_EMAIL";
export const SET_EMAIL_VALUE = "SET_EMAIL_VALUE";

export const SAVE_MAILBOX_FILE_SUCCESS = "SAVE_MAILBOX_FILE_SUCCESS";
export const SAVE_MAILBOX_FILE_ERROR = "SAVE_MAILBOX_FILE_ERROR";
export const RESET_MAILBOX_FILE = "RESET_MAILBOX_FILE";

export const SAVE_CALENDAR_DATA_SUCCESS = "SAVE_CALENDAR_DATA_SUCCESS";
export const SAVE_CALENDAR_DATA_ERROR = "SAVE_CALENDAR_DATA_ERROR";
export const RESET_CALENDAR_DATA = "RESET_CALENDAR_DATA";

export const UPDATE_CALENDAR_DATA_SUCCESS = "UPDATE_CALENDAR_DATA_SUCCESS";
export const UPDATE_CALENDAR_DATA_ERROR = "UPDATE_CALENDAR_DATA_ERROR";
export const RESET_CALENDAR_DATA_UPDATE = "RESET_CALENDAR_DATA_UPDATE";

export const CREATE_MAIL_GROUP_SUCCESS = "CREATE_MAIL_GROUP_SUCCESS";
export const CREATE_MAIL_GROUP_FAILED = "CREATE_MAIL_GROUP_FAILED";

export const GET_NOT_READ_EMAILS_SUCCESS = "GET_NOT_READ_EMAILS_SUCCESS";
export const GET_NOT_READ_EMAILS_FAILED = "GET_NOT_READ_EMAILS_FAILED";
export const UPDATE_UNREAD_EMAIL_COUNT = "UPDATE_UNREAD_EMAIL_COUNT";

export const EDIT_MAIL_GROUP_SUCCESS = "EDIT_MAIL_GROUP_SUCCESS";
export const EDIT_MAIL_GROUP_FAILED = "EDIT_MAIL_GROUP_FAILED";

export const EDIT_MAIL_GROUP_READ_BY_SUCCESS =
  "EDIT_MAIL_GROUP_READ_BY_SUCCESS";
export const EDIT_MAIL_GROUP_READ_BY_FAILED = "EDIT_MAIL_GROUP_READ_BY_FAILED";

export const DELETE_MAIL_GROUP_SUCCESS = "DELETE_MAIL_GROUP_SUCCESS";
export const DELETE_MAIL_GROUP_FAILED = "DELETE_MAIL_GROUP_FAILED";

export const GET_ALL_MAIL_GROUP_SUCCESS = "GET_ALL_MAIL_GROUP_SUCCESS";
export const GET_ALL_MAIL_GROUP_FAILED = "GET_ALL_MAIL_GROUP_FAILED";

export const RESET_MAIL_GROUP_DETAILS = "RESET_MAIL_GROUP_DETAILS";

// Gradebook
export const CREATE_GRADEBOOK_CATEGORIES_SUCCESS =
  "CREATE_GRADEBOOK_CATEGORIES_SUCCESS";
export const CREATE_GRADEBOOK_CATEGORIES_FAILED =
  "CREATE_GRADEBOOK_CATEGORIES_FAILED";

export const GET_ALL_GRADEBOOK_CATEGORIES_SUCCESS =
  "GET_ALL_GRADEBOOK_CATEGORIES_SUCCESS";
export const GET_ALL_GRADEBOOK_CATEGORIES_FAILED =
  "GET_ALL_GRADEBOOK_CATEGORIES_FAILED";

export const DELETE_GRADEBOOK_CATEGORIES_SUCCESS =
  "DELETE_GRADEBOOK_CATEGORIES_SUCCESS";
export const DELETE_GRADEBOOK_CATEGORIES_FAILED =
  "DELETE_GRADEBOOK_CATEGORIES_FAILED";

export const UPDATE_GRADEBOOK_CATEGORIES_SUCCESS =
  "UPDATE_GRADEBOOK_CATEGORIES_SUCCESS";
export const UPDATE_GRADEBOOK_CATEGORIES_FAILED =
  "UPDATE_GRADEBOOK_CATEGORIES_FAILED";
export const GET_GRADEBOOK_COURSE_ATTENDEES_DETAILS =
  "GET_GRADEBOOK_COURSE_ATTENDEES_DETAILS";
export const GET_GRADEBOOK_COURSE_ATTENDEES_SUCCESS =
  "GET_GRADEBOOK_COURSE_ATTENDEES_SUCCESS";
export const GET_GRADEBOOK_COURSE_ATTENDEES_FAILED =
  "GET_GRADEBOOK_COURSE_ATTENDEES_FAILED";

export const UPDATE_FINAL_GRADES_SUCCESS = "UPDATE_FINAL_GRADES_SUCCESS";
export const UPDATE_FINAL_GRADES_FAILED = "UPDATE_FINAL_GRADES_FAILED";

export const DELETE_FINAL_GRADES_SUCCESS = "DELETE_FINAL_GRADES_SUCCESS";
export const DELETE_FINAL_GRADES_FAILED = "DELETE_FINAL_GRADES_FAILED";

export const GET_FINAL_GRADES_SUCCESS = "GET_FINAL_GRADES_SUCCESS";
export const GET_FINAL_GRADES_FAILED = "GET_FINAL_GRADES_FAILED";

// Gradebook Group

export const GET_ALL_GRADEBOOK_ITEM_GROPU_SUCCESS =
  "GET_ALL_GRADEBOOK_ITEM_GROPU_SUCCESS";
export const GET_ALL_GRADEBOOK_ITEM_GROPU_FAILED =
  "GET_ALL_GRADEBOOK_ITEM_GROPU_FAILED";

export const CREATE_GRADBOOK_GROUP_SUCCESS = "CREATE_GRADBOOK_GROUP_SUCCESS";
export const CREATE_GRADBOOK_GROUP_FAILED = "CREATE_GRADBOOK_GROUP_FAILED";

//Items
export const CREATE_GRADEBOOK_ITEMS_SUCCESS = "CREATE_GRADEBOOK_ITEMS_SUCCESS";
export const CREATE_GRADEBOOK_ITEMS_FAILED = "CREATE_GRADEBOOK_ITEMS_FAILED";

export const GET_ALL_GRADEBOOK_ITEMS_SUCCESS =
  "GET_ALL_GRADEBOOK_ITEMS_SUCCESS";
export const GET_ALL_GRADEBOOK_ITEMS_FAILED = "GET_ALL_GRADEBOOK_ITEMS_FAILED";

export const DELETE_GRADEBOOK_ITEMS_SUCCESS = "DELETE_GRADEBOOK_ITEMS_SUCCESS";
export const DELETE_GRADEBOOK_ITEMS_FAILED = "DELETE_GRADEBOOK_ITEMS_FAILED";

export const UPDATE_GRADEBOOK_ITEMS_SUCCESS = "UPDATE_GRADEBOOK_ITEMS_SUCCESS";
export const UPDATE_GRADEBOOK_ITEMS_FAILED = "UPDATE_GRADEBOOK_ITEMS_FAILED";
export const RESET_GRADEBOOK_ITEMS = "RESET_GRADEBOOK_ITEMS";

export const GET_CATEGORIES_DROPDOWN = "GET_CATEGORIES_DROPDOWN";
export const RESET_CATEGORIES_DROPDOWN = "RESET_CATEGORIES_DROPDOWN";

export const CREATE_SINGLE_USER_FILE_SUCCESS =
  "CREATE_SINGLE_USER_FILE_SUCCESS";

export const GET_ALL_USER_CSV_SUCCESS = "GET_ALL_USER_CSV_SUCCESS";
export const GET_ALL_USER_CSV_FAILED = "GET_ALL_USER_CSV_FAILED";

export const GET_PASSED_STUDENTS_CSV_SUCCESS =
  "GET_PASSED_STUDENTS_CSV_SUCCESS";
export const GET_PASSED_STUDENTS_CSV_FAILED = "GET_PASSED_STUDENTS_CSV_FAILED";

// My Grades

export const GET_MY_GRADES_SUCCESS = "GET_MY_GRADES_SUCCESS";
export const GET_MY_GRADES_FAILED = "GET_MY_GRADES_FAILED";

//Certificates
export const CREATE_CERTIFICATES_SUCCESS = "CREATE_CERTIFICATES_SUCCESS";
export const CREATE_CERTIFICATES_FAILED = "CREATE_CERTIFICATES_FAILED";
export const GET_CERTIFICATE_LIST_SUCCESS = "GET_CERTIFICATE_LIST_SUCCESS";
export const GET_CERTIFICATE_LIST_FAILED = "GET_CERTIFICATE_LIST_FAILED";
export const DELETE_CERTIFICATE_SUCCESS = "DELETE_CERTIFICATE_SUCCESS";
export const DELETE_CERTIFICATE_FAILED = "DELETE_CERTIFICATE_FAILED";
export const UPDATE_CERTIFICATE_SUCCESS = "UPDATE_CERTIFICATE_SUCCESS";
export const UPDATE_CERTIFICATE_FAILED = "UPDATE_CERTIFICATE_FAILED";
export const GET_CERTIFICATE_DETAILS_SUCCESS =
  "GET_CERTIFICATE_DETAILS_SUCCESS";
export const GET_CERTIFICATE_LIST_FOR_DROPDOWN_SUCCESS =
  "GET_CERTIFICATE_LIST_FOR_DROPDOWN_SUCCESS";
export const GET_CERTIFICATE_LIST_FOR_DROPDOWN_FAILED =
  "GET_CERTIFICATE_LIST_FOR_DROPDOWN_FAILED";
export const GET_CERTIFICATE_LIST_FOR_DROPDOWN =
  "GET_CERTIFICATE_LIST_FOR_DROPDOWN";

export const GET_CERTIFICATE_DETAILS_FAILED = "GET_CERTIFICATE_DETAILS_FAILED";

export const GET_DUPLICATE_CERTIFICATE_SUCCESS =
  "GET_DUPLICATE_CERTIFICATE_SUCCESS";
export const GET_DUPLICATE_CERTIFICATE_FAILED =
  "GET_DUPLICATE_CERTIFICATE_FAILED";
//Gradebook
export const GET_ALL_DROPBOX_CATEGORY_WEIGHT_SUCCESS =
  "GET_ALL_DROPBOX_CATEGORY_WEIGHT_SUCCESS";
export const GET_ALL_GRADBOOK_DROPDOWN_SUCCESS =
  "GET_ALL_GRADBOOK_DROPDOWN_SUCCESS";
export const GET_ALL_GRADBOOK_DROPDOWN_ERROR =
  "GET_ALL_GRADBOOK_DROPDOWN_ERROR";
export const GET_ALL_DROPBOX_CATEGORY_WEIGHT_ERROR =
  "GET_ALL_DROPBOX_CATEGORY_WEIGHT_ERROR";
export const GET_ALL_DISCUSSION_CATEGORY_WEIGHT_SUCCESS =
  "GET_ALL_DISCUSSION_CATEGORY_WEIGHT_SUCCESS";
export const GET_ALL_DISCUSSION_CATEGORY_WEIGHT_ERROR =
  "GET_ALL_DISCUSSION_CATEGORY_WEIGHT_ERROR";
export const RESET_DROPBOX_CATEGORY_WEIGHT = "RESET_DROPBOX_CATEGORY_WEIGHT";
export const RESET_DISCUSSION_CATEGORY_WEIGHT =
  "RESET_DISCUSSION_CATEGORY_WEIGHT";

//To save image data
export const CREATE_POST_COMMENT_FILE_SUCCESS =
  "CREATE_POST_COMMENT_FILE_SUCCESS";

//Discussion post grade
export const SAVE_DISCUSSION_POST_GRADE_SUCCESS =
  "SAVE_DISCUSSION_POST_GRADE_SUCCESS";
export const SAVE_DISCUSSION_POST_GRADE_FAILED =
  "SAVE_DISCUSSION_POST_GRADE_FAILED";

export const GET_DISCUSSION_POST_GRADE_SUCCESS =
  "GET_DISCUSSION_POST_GRADE_SUCCESS";
export const GET_DISCUSSION_POST_GRADE_FAILED =
  "GET_DISCUSSION_POST_GRADE_FAILED";

//Get Gradebook Item for dropdown
export const GET_GRADEBOOK_LIST_DROPDOWN = "GET_GRADEBOOK_LIST_DROPDOWN";
export const GET_GRADEBOOK_LIST_DROPDOWN_ERROR =
  "GET_GRADEBOOK_LIST_DROPDOWN_ERROR";

export const GET_GRADEBOOK_STUDENT_GRADE_SUCCESS =
  "GET_GRADEBOOK_STUDENT_GRADE_SUCCESS";
export const GET_GRADEBOOK_STUDENT_GRADE_FAILED =
  "GET_GRADEBOOK_STUDENT_GRADE_FAILED";

export const RESET_GRADEBOOK_STUDENT_GRADE = "RESET_GRADEBOOK_STUDENT_GRADE";
// Dashboard
export const GET_DASHBOARD_USER_COURSE_LIST = "GET_DASHBOARD_USER_COURSE_LIST";

export const GET_DASHBOARD_USER_COURSE_LIST_SUCCESS =
  "GET_DASHBOARD_USER_COURSE_LIST_SUCCESS";

export const GET_DASHBOARD_USER_COURSE_LIST_FAILED =
  "GET_DASHBOARD_USER_COURSE_LIST_FAILED";

export const GET_DASHBOARD_ACTIVE_COURSE_LIST_SUCCESS =
  "GET_DASHBOARD_ACTIVE_COURSE_LIST_SUCCESS";

export const UPDATE_TESTS_GRADEBOOK_SUCCESS = "UPDATE_TESTS_GRADEBOOK_SUCCESS";
export const UPDATE_TESTS_GRADEBOOK_FAILED = "UPDATE_TESTS_GRADEBOOK_FAILED";

export const GET_DASHBOARD_CALENDAR_EVENT = "GET_DASHBOARD_CALENDAR_EVENT";
export const GET_DASHBOARD_CALENDAR_EVENT_SUCCESS =
  "GET_DASHBOARD_CALENDAR_EVENT_SUCCESS";

export const GET_DASHBOARD_CALENDAR_EVENT_FAILED =
  "GET_DASHBOARD_CALENDAR_EVENT_FAILED";

export const GET_RSVP_BY_CALENDAR_ID_SUCCESS =
  "GET_RSVP_BY_CALENDAR_ID_SUCCESS";
export const GET_RSVP_BY_CALENDAR_ID_FAILED = "GET_RSVP_BY_CALENDAR_ID_FAILED";

// Start End Dates Module
export const GET_DISCUSIION_COURSEID_SUCCESS =
  "GET_DISCUSIION_COURSEID_SUCCESS";
export const GET_DISCUSIION_COURSEID_ERROR = "GET_DISCUSIION_COURSEID_ERROR";

export const GET_DISCUSIION_POST_COURSEID_SUCCESS =
  "GET_DISCUSIION_POST_COURSEID_SUCCESS";
export const GET_DISCUSIION_POST_COURSEID_ERROR =
  "GET_DISCUSIION_POST_COURSEID_ERROR";

export const GET_DROPBOX_COURSEID_SUCCESS = "GET_DROPBOX_COURSEID_SUCCESS";
export const GET_DROPBOX_COURSEID_ERROR = "GET_DROPBOX_COURSEID_ERROR";

export const GET_GRADEBOOK_ITEM_COURSEID_SUCCESS =
  "GET_GRADEBOOK_ITEM_COURSEID_SUCCESS";
export const GET_GRADEBOOK_ITEM_COURSEID_ERROR =
  "GET_GRADEBOOK_ITEM_COURSEID_ERROR";

export const RESET_USER_BY_ID_SUCCESS = "RESET_USER_BY_ID_SUCCESS";

//cloning
export const CLONE_COURSE_SUCCESS = "CLONE_COURSE_SUCCESS";
export const CLONE_COURSE_FAILED = "CLONE_COURSE_FAILED";

//Gradebook grade
export const GET_GRADEBOOK_GRADE_SUCCESS = "GET_GRADEBOOK_GRADE_SUCCESS";
export const GET_GRADEBOOK_GRADE_FAILED = "GET_GRADEBOOK_GRADE_FAILED";

export const CREATE_GRADEBOOK_GRADE_SUCCESS = "CREATE_GRADEBOOK_GRADE_SUCCESS";
export const CREATE_GRADEBOOK_GRADE_FAILED = "CREATE_GRADEBOOK_GRADE_FAILED";

export const UPDATE_GRADEBOOK_GRADE_SUCCESS = "UPDATE_GRADEBOOK_GRADE_SUCCESS";
export const UPDATE_GRADEBOOK_GRADE_FAILED = "UPDATE_GRADEBOOK_GRADE_FAILED";

export const DELETE_GRADEBOOK_GRADE_SUCCESS = "DELETE_GRADEBOOK_GRADE_SUCCESS";
export const DELETE_GRADEBOOK_GRADE_FAILED = "DELETE_GRADEBOOK_GRADE_FAILED";
// Step 1
export const GET_LESSON_DETAILS_BY_COURSEID = "GET_LESSON_DETAILS_BY_COURSEID";
export const GET_LESSON_DETAILS_BY_COURSEID_FAILED =
  "GET_LESSON_DETAILS_BY_COURSEID_FAILED";

export const GET_TEST_DETAILS_BY_COURSEID = "GET_TEST_DETAILS_BY_COURSEID";
export const GET_TEST_DETAILS_BY_COURSEID_FAILED =
  "GET_TEST_DETAILS_BY_COURSEID_FAILED";

export const GET_LOGIN_HOSTORY_PAST_30_DAYS = "GET_LOGIN_HOSTORY_PAST_30_DAYS";
export const GET_LOGIN_HOSTORY_PAST_30_DAYS_FAILED =
  "GET_LOGIN_HOSTORY_PAST_30_DAYS_FAILED";
export const RESET_LOGIN_HOSTORY_PAST_30_DAYS =
  "RESET_LOGIN_HOSTORY_PAST_30_DAYS";

export const GET_LOGIN_ROLE_COUNT = "GET_LOGIN_ROLE_COUNT";
export const GET_LOGIN_ROLE_COUNT_FAILED = "GET_LOGIN_ROLE_COUNT_FAILED";
export const RESET_LOGIN_ROLE_COUNT = "RESET_LOGIN_ROLE_COUNT";

export const DELETE_SELECTED_DROPBOX_SUCESS = "DELETE_SELECTED_DROPBOX_SUCESS";
export const DELETE_SELECTED_DROPBOX_FAILED = "DELETE_SELECTED_DROPBOX_FAILED";

export const UPDATE_DROPBOX_SETTING_SUCCESS = "UPDATE_DROPBOX_SETTING_SUCCESS";
export const UPDATE_DROPBOX_SETTING_ERROR = "UPDATE_DROPBOX_SETTING_ERROR";

export const UPDATE_LESSON_SETTING_SUCCESS = "UPDATE_LESSON_SETTING_SUCCESS";
export const UPDATE_LESSON_SETTING_ERROR = "UPDATE_LESSON_SETTING_ERROR";

export const UPLOAD_LOGO_RESPONSE = "UPLOAD_LOGO_RESPONSE";

export const UPDATE_GRADEBOOK_SETTING_SUCCESS =
  "UPDATE_GRADEBOOK_SETTING_SUCCESS";
export const UPDATE_GRADEBOOK_SETTING_ERROR = "UPDATE_GRADEBOOK_SETTING_ERROR";

export const UPDATE_FULL_GRADEBOOK_SUCCESS = "UPDATE_FULL_GRADEBOOK_SUCCESS";
export const UPDATE_FULL_GRADEBOOK_ERROR = "UPDATE_FULL_GRADEBOOK_ERROR";

export const GET_COURSE_PROGRESS_SUCCESS = "GET_COURSE_PROGRESS_SUCCESS";
export const GET_COURSE_PROGRESS_FAILED = "GET_COURSE_PROGRESS_FAILED";

export const GET_STUDENT_CERTIFICATE_SAVED_SUCESS =
  "GET_STUDENT_CERTIFICATE_SAVED_SUCESS";
export const GET_STUDENT_CERTIFICATE_SAVED_FAILED =
  "GET_STUDENT_CERTIFICATE_SAVED_FAILED";

export const GET_ALL_STUDENT_CERTIFICATE_SAVED_SUCESS =
  "GET_ALL_STUDENT_CERTIFICATE_SAVED_SUCESS";
export const GET_ALL_STUDENT_CERTIFICATE_SAVED_FAILED =
  "GET_ALL_STUDENT_CERTIFICATE_SAVED_FAILED";

// Get login count for past 30 days
export const GET_LOGIN_COUNT_HISTORY_SUCCESS =
  "GET_LOGIN_COUNT_HISTORY_SUCCESS";
export const GET_LOGIN_COUNT_HISTORY_ERROR = "GET_LOGIN_COUNT_HISTORY_ERROR";

// Get login count for past 30 days
export const GET_TOTAL_USAGE_SIX_MONTHS_SUCCESS =
  "GET_TOTAL_USAGE_SIX_MONTHS_SUCCESS";
export const GET_TOTAL_USAGE_SIX_MONTHS_ERROR =
  "GET_TOTAL_USAGE_SIX_MONTHS_ERROR";

export const GET_DROPBOX_NOTIFICATION_SUCCESS =
  "GET_DROPBOX_NOTIFICATION_SUCCESS";
export const GET_DROPBOX_NOTIFICATION_ERROR = "GET_DROPBOX_NOTIFICATION_ERROR";

export const MARK_DROPBOX_NOTIFICATION_SUCCESS =
  "MARK_DROPBOX_NOTIFICATION_SUCCESS";
export const MARK_DROPBOX_NOTIFICATION_ERROR =
  "MARK_DROPBOX_NOTIFICATION_ERROR";

export const GET_TERMS_COURSE_SUCCESS = "GET_TERMS_COURSE_SUCCESS";
export const GET_TERMS_COURSE_ERROR = "GET_TERMS_COURSE_ERROR";

export const GET_GRADE_BOOK_TEST_ITEM_SUCCESS =
  "GET_GRADE_BOOK_TEST_ITEM_SUCCESS";
export const GET_GRADE_BOOK_TEST_ITEM_ERROR = "GET_GRADE_BOOK_TEST_ITEM_ERROR";

export const SAVE_TEST_GRADEBOOK_GRADE_SUCCESS =
  "SAVE_TEST_GRADEBOOK_GRADE_SUCCESS";
export const SAVE_TEST_GRADEBOOK_GRADE_ERROR =
  "SAVE_TEST_GRADEBOOK_GRADE_ERROR";

export const GET_MODULE_SETTING_SUCCESS = "GET_MODULE_SETTING_SUCCESS";
export const GET_MODULE_SETTING_ERROR = "GET_MODULE_SETTING_ERROR";
export const UPDATE_MODULE_SETTING_SUCCESS = "UPDATE_MODULE_SETTING_SUCCESS";
export const UPDATE_MODULE_SETTING_ERROR = "UPDATE_MODULE_SETTING_ERROR";

export const GET_TEACHING_ASSISTANT_SUCCESS = "GET_TEACHING_ASSISTANT_SUCCESS";
export const GET_TEACHING_ASSISTANT_ERROR = "GET_TEACHING_ASSISTANT_ERROR";
export const UPDATE_TEACHING_ASSISTANT_SUCCESS =
  "UPDATE_TEACHING_ASSISTANT_SUCCESS";
export const UPDATE_TEACHING_ASSISTANT_ERROR =
  "UPDATE_TEACHING_ASSISTANT_ERROR";

export const GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_SUCCESS =
  "GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_SUCCESS";
export const GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_ERROR =
  "GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_ERROR";

export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILED = "GET_NOTIFICATIONS_FAILED";

export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_ERROR = "UPDATE_NOTIFICATION_ERROR";

export const UPLOAD_MULTIPLE_FILES_SUCCESS = "UPLOAD_MULTIPLE_FILES_SUCCESS";
export const UPLOAD_MULTIPLE_FILES_ERROR = "UPLOAD_MULTIPLE_FILES_ERROR";

export const GET_MARKETING_RECORDS_SUCCESS = "GET_MARKETING_RECORDS_SUCCESS";
export const GET_MARKETING_RECORDS_ERROR = "GET_MARKETING_RECORDS_ERROR";
export const RESET_MARKETING_RECORDS_DATA = "RESET_MARKETING_RECORDS_DATA";

export const GET_COURSEFACILATION_REPORT_SUCCESS =
  "GET_COURSEFACILATION_REPORT_SUCCESS";
export const GET_COURSEFACILATION_REPORT_ERROR =
  "GET_COURSEFACILATION_REPORT_ERROR";
export const RESET_COURSE_FACILATION_DATA = "RESET_COURSE_FACILATION_DATA";

export const GET_FILTER_RECORDS_SUCCESS = "GET_FILTER_RECORDS_SUCCESS";
export const GET_FILTER_RECORDS_ERROR = "GET_FILTER_RECORDS_ERROR";

export const GET_COURSE_ENROLLMENT_RECORDS_SUCCESS =
  "GET_COURSE_ENROLLMENT_RECORDS_SUCCESS";
export const GET_COURSE_ENROLLMENT_RECORDS_ERROR =
  "GET_COURSE_ENROLLMENT_RECORDS_ERROR";

export const GET_EVALUATION_RECORDS_SUCCESS = "GET_EVALUATION_RECORDS_SUCCESS";
export const GET_EVALUATION_RECORDS_ERROR = "GET_EVALUATION_RECORDS_ERROR";
export const RESET_EVALUATION_RECORDS = "RESET_EVALUATION_RECORDS";

export const GET_GRADEBOOK_NOTIFICATION_SUCCESS =
  "GET_GRADEBOOK_NOTIFICATION_SUCCESS";
export const GET_GRADEBOOK_NOTIFICATION_ERROR =
  "GET_GRADEBOOK_NOTIFICATION_ERROR";

export const MARK_GRADEBOOK_NOTIFICATION_SUCCESS =
  "MARK_GRADEBOOK_NOTIFICATION_SUCCESS";
export const MARK_GRADEBOOK_NOTIFICATION_ERROR =
  "MARK_GRADEBOOK_NOTIFICATION_ERROR";

export const SEND_EMAIL_TO_USER_SUCCESS = "SEND_EMAIL_TO_USER_SUCCESS";
export const SEND_EMAIL_TO_USER_ERROR = "SEND_EMAIL_TO_USER_ERROR";
export const GET_SEMI_ANNUAL_REPORT_RECORDS_SUCCESS =
  "GET_SEMI_ANNUAL_REPORT_RECORDS_SUCCESS";
export const GET_SEMI_ANNUAL_REPORT_RECORDS_ERROR =
  "GET_SEMI_ANNUAL_REPORT_RECORDS_ERROR";
export const RESET_LESSON_CONTENT = "RESET_LESSON_CONTENT";

export const RESET_DISCUSSIONS_DATA = "RESET_DISCUSSIONS_DATA";

//Clones
export const GET_ALL_COURSE_CLONES = "GET_ALL_COURSE_CLONES";
export const GET_ALL_COURSE_CLONES_ERROR = "GET_ALL_COURSE_CLONES_ERROR";

export const GET_ALL_COURSE_CLONES_DETAILS = "GET_ALL_COURSE_CLONES_DETAILS";
export const GET_ALL_COURSE_CLONES_DETAILS_ERROR =
  "GET_ALL_COURSE_CLONES_DETAILS_ERROR";

export const GET_FINALIZE_STUDENTS = "GET_FINALIZE_STUDENTS";
export const GET_FINALIZE_STUDENTS_ERROR = "GET_FINALIZE_STUDENTS_ERROR";

export const CREATE_FINALIZE_STUDENTS = "CREATE_FINALIZE_STUDENTS";
export const CREATE_FINALIZE_STUDENTS_ERROR = "CREATE_FINALIZE_STUDENTS_ERROR";

// Terms

export const SAVE_GRADEBOOK_ATTENDANCE_REQUEST =
  "SAVE_GRADEBOOK_ATTENDANCE_REQUEST";
export const SAVE_GRADEBOOK_ATTENDANCE_SUCCESS =
  "SAVE_GRADEBOOK_ATTENDANCE_SUCCESS";
export const SAVE_GRADEBOOK_ATTENDANCE_FAILED =
  "SAVE_GRADEBOOK_ATTENDANCE_FAILED";
export const GET_GRADEBOOK_ATTENDANCE_SUCCESS =
  "GET_GRADEBOOK_ATTENDANCE_SUCCESS";
export const GET_GRADEBOOK_ATTENDANCE_FAILED =
  "GET_GRADEBOOK_ATTENDANCE_FAILED";

export const SAVE_ATTENDANCE_IN_GB_SUCCESS = "SAVE_ATTENDANCE_IN_GB_SUCCESS";
export const SAVE_ATTENDANCE_IN_GB_FAILED = "SAVE_ATTENDANCE_IN_GB_FAILED";
export const ATTENDEE_CHECK_GB = "ATTENDEE_CHECK_GB";

export const GET_SINGLE_TEST_TRACKER_SUCCESS =
  "GET_SINGLE_TEST_TRACKER_SUCCESS";
export const GET_SINGLE_TEST_TRACKER_FAILED = "GET_SINGLE_TEST_TRACKER_FAILED";
export const RESET_SINGLE_TEST_TRACKER = "RESET_SINGLE_TEST_TRACKER";

export const GET_COURSE_BY_USER_ID_SUCCESS = "GET_COURSE_BY_USER_ID_SUCCESS";
export const GET_COURSE_BY_USER_ID_FAILED = "GET_COURSE_BY_USER_ID_FAILED";

export const GET_WOO_COMMERCE_SKUS_SUCCESS = "GET_WOO_COMMERCE_SKUS_SUCCESS";
export const GET_WOO_COMMERCE_SKUS_ERROR = "GET_WOO_COMMERCE_SKUS_ERROR";

///learner-verification
export const VERIFY_LEARNER_SUCCESS = "VERIFY_LEARNER_SUCCESS";
export const VERIFY_LEARNER_FAILURE = " VERIFY_LEARNER_FAILURE";
export const RESET_LEARNER_SUCCESS = "RESET_LEARNER_SUCCESS";
export const EDIT_MAIL_TEMPLATE_SUCCESS = "EDIT_MAIL_TEMPLATE_SUCCESS";
export const EDIT_MAIL_TEMPLATE_FAILED = "EDIT_MAIL_TEMPLATE_FAILED";

export const GET_EMAIL_TAMPLATE_DROPDOWN_SUCCESS =
  "GET_EMAIL_TAMPLATE_DROPDOWN_SUCCESS";
export const GET_EMAIL_TAMPLATE_DROPDOWN_ERROR =
  "GET_EMAIL_TAMPLATE_DROPDOWN_ERROR";
